module.exports = __webpack_public_path__ + "static/img/发展历程.fab8493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/发展历程.png
// module id = RhEg
// module chunks = 6